import { Button, Collapse } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { ReactComponent as DeleteShareIcon } from "../../../../../assets/svgs/icons/delete-share-icon.svg";
import { ReactComponent as EditIcon } from "../../../../../assets/svgs/icons/edit-icon.svg";
import { ReactComponent as InfoIcon } from "../../../../../assets/svgs/icons/info-icon.svg";
import PermissionAccessDetail from '../shareDetails/PermissionAccessDetail';
import { checkboxConfig } from '../PermissionType';

const collapseItems = [
    {
        id: 'Permission Group 1',
        email: 'test1@gmail.com',
        data: [
            { id: 'Group 1', perms: ['view', 'process'] },
            { id: 'Group 2', perms: ['view'] }
        ],
    },
    {
        id: 'Permission Group 2',
        email: 'test2@gmail.com',
        data: [
            { id: 'Group 1', perms: ['view'] },
            { id: 'Group 2', perms: ['process, download'] },
            { id: 'Group 3', perms: ['view, download, process'] }
        ],
    },
    {
        id: 'data',
        email: 'test3@gmail.com',
        data: [
            { id: 'Group 1', perms: ['view, download'] }
        ],
    },
    {
        id: 'Permission Group 4',
        email: 'test4@gmail.com',
        data: [
            { id: 'Group 1', perms: ['view'] },
            { id: 'Group 2', perms: ['process, download'] },
            { id: 'Group 3', perms: ['view, download, process'] }
        ],
    },
];

interface SharedUserDetailProps {
    handleCancel: () => void;
}

const SharedUserDetails = ({ handleCancel }: SharedUserDetailProps) => {
    const [sharedData, setSharedData] = useState(collapseItems);
    const [activeKey, setActiveKey] = useState('');
    const [editRowIndex, setEditRowIndex] = useState<number | null>(null);
    const [checkedItems, setCheckedItems] = useState<Record<string, boolean>>({});
    const editRowRef = useRef<HTMLDivElement | null>(null);

    const togglePanel = (key: any) => {
        setActiveKey(activeKey === key ? '' : key);
    };

    const handleUserShare = () => {
        handleCancel();
    };

    const handleEditClick = (index: number, perms: string[]) => {
        setEditRowIndex(index);
        const newCheckedItems = checkboxConfig.reduce((acc, checkbox) => {
            acc[checkbox.name] = perms.includes(checkbox.name);
            return acc;
        }, {} as Record<string, boolean>);
        setCheckedItems(newCheckedItems);
    };

    const handleCheckboxChange = (e: any) => {
        const { name, checked } = e.target;
        setCheckedItems(prevState => ({ ...prevState, [name]: checked }));
    };

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (editRowRef.current && !editRowRef.current.contains(event.target as Node)) {
                setEditRowIndex(null);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className='share_detail_collapse'>
            <Collapse accordion activeKey={activeKey} onChange={togglePanel}>
                {sharedData && sharedData.map(item => (
                    <Collapse.Panel key={item?.email} header={item?.email}>
                        <div className='collapse_inner_box'>
                            <table>
                                <tbody>
                                    {item?.data.map((perm, index) => (
                                        <tr key={index} className="collapse_table_row">
                                            <td style={{ minWidth: 100, maxWidth: 100 }}>{perm.id}</td>
                                            <td style={{ minWidth: 300, maxWidth: 300 }}>{perm.perms.join(', ')}</td>
                                            <td className='action_cell'>
                                                <div className='action_icon_box'>
                                                    <InfoIcon key="InfoIcon" color='#ffffff' />
                                                    <div className='edit_icon_box'>
                                                        <EditIcon style={{ cursor: "pointer" }} key="EditIcon" color='#ffffff' onClick={() => handleEditClick(index, perm.perms)} />
                                                        {editRowIndex === index && (
                                                            <div ref={editRowRef} className='edit_row_box'>
                                                                <PermissionAccessDetail
                                                                    checkedItems={checkedItems}
                                                                    onCheckboxChange={handleCheckboxChange}
                                                                />
                                                            </div>
                                                        )}
                                                    </div>
                                                    <DeleteShareIcon key="DeleteShareIcon" color='#ffffff' />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Collapse.Panel>
                ))}
            </Collapse>

            <div className="share_footer_box">
                <Button type="primary" className="ok_batch_button share_footer_btn" onClick={handleUserShare}>
                    Ok
                </Button>
            </div>
        </div>
    );
}

export default SharedUserDetails;